<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.feedback") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>{{ $t("management.documentType") }}</th>
            <td colspan="5">
              <ul class="group_sel_ul">
                <li>
                  <select v-model="form.docTypeId" class="int_type01 mgt_seltype">
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(doc, index) in docTypeList"
                      :key="index"
                      :value="doc.doctypeId"
                    >
                      {{ doc.doctypeDesc }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.productType") }}</th>
            <td colspan="5">
              <ul class="group_sel_ul">
                <li>
                  <em>{{ $t("management.mainCategory") }}</em>
                  <select
                    v-model="form.upperProdId"
                    class="int_type01 mgt_seltype"
                    @change="getSubProducts(form.upperProdId)"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(prod, index) in mainProd"
                      :key="index"
                      :value="prod.prodId"
                    >
                      {{ prod.prodName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("management.subCategory") }}</em>
                  <select v-model="form.prodId" class="int_type01 mgt_seltype">
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(subProd, index) in subProductType"
                      :key="index"
                      :value="subProd.prodId"
                    >
                      {{ subProd.prodName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.language") }}</th>
            <td>
              <select v-model="form.lang" class="int_type01 mgt_seltype">
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(lang, index) in langList"
                  :key="index"
                  :value="lang.codeId"
                >
                  {{ lang.codeName }}
                </option>
              </select>
            </td>
            <th>{{ $t("common.date") }}</th>
            <td colspan="3" class="d-flex">
              <b-form-datepicker
                v-model="form.startDate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                @input="checkDate"
                label-no-date-selected=""
              ></b-form-datepicker>
              ~
              <b-form-datepicker
                v-model="form.endDate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                @input="checkDate"
                label-no-date-selected=""
              ></b-form-datepicker>
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.state") }}</th>
            <td>
              <select
                v-model="form.searchState"
                class="int_type01 mgt_seltype int_w_full"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="Y">{{ $t("support.qna.answered") }}</option>
                <option value="N">{{ $t("support.qna.answering") }}</option>
              </select>
            </td>
            <th>{{ $t("product.distribute") }}</th>
            <td>
              <select
                v-model="form.publishedYN"
                class="int_type01 mgt_seltype int_w_full"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="P">{{ $t("product.distribute") }}</option>
                <option value="N">{{ $t("product.unDistribute") }}</option>
              </select>
            </td>
            <th>{{ $t("management.user") }}</th>
            <td>
              <input
                type="text"
                v-model="form.searchWord"
                class="int_type01 mgt_seltype"
                title="사용자 검색"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mgt_option_bottom">
      <button @click="searchBtn" class="btn btn-primary">
        {{ $t("common.search") }}
      </button>
    </div>
    <div class="sub_line_tab">
      <ul>
        <li>
          <a
            href="javascript:void(0)"
            @click="[(tabName = 'all'), getAll()]"
            :class="{ on: tabName == 'all' }"
            >{{ $t("common.all") }}</a
          >
        </li>
        <!-- <li>
          <a
            href="javascript:void(0)"
            @click="[(tabName = 'my'), getFeedbackManager()]"
            :class="{ on: tabName == 'my' }"
            >{{ $t("management.feedbackImgoingtoAnswer") }}</a
          >
        </li> -->
      </ul>
    </div>
    <div class="view_re_list_wrap">
      <div v-if="feedbackList != null" style="overflow: auto; height: 700px">
        <div
          v-for="(feedback, index) in feedbackList"
          :key="index"
          class="view_re_list_box"
        >
          <div class="re_con_box">
            <div class="v_r_user d-flex">
              <span>{{ feedback.userName }}</span>
              {{ feedback.userName }}
              <em>{{ feedback.firstRegDatetime }}</em>
              <a :href="feedback.pageId" target="_blank" class="view_docbtn m-1"
                >View DOC</a
              >
            </div>
            <p class="re_con_t">{{ feedback.content }}</p>
            <div class="re_con_bt">
              <ul>
                <li>
                  <a href="javascript:void(0)" @click="deleteFeedback(feedback)">{{
                    $t("common.delete")
                  }}</a>
                </li>
                <li>
                  <a
                    href="javascript:void(0)"
                    @click="showAnswerBox(feedback.feedbackId)"
                    >{{ $t("common.writeAnswer") }}</a
                  >
                </li>
              </ul>
            </div>
            <!--댓글 있을시-->
            <span v-for="(answer, index) in answerList" :key="index">
              <div v-if="answer.parentId == feedback.feedbackId" class="con_re_box">
                <div class="v_r_user">
                  <span>{{ answer.userName }}</span
                  >{{ answer.userName }}<em>{{ answer.firstRegDatetime }}</em>
                </div>
                <p>{{ answer.content }}</p>
                <div class="re_con_bt">
                  <ul>
                    <li>
                      <a href="javascript:void(0)" @click="deleteFeedback(answer)">{{
                        $t("common.delete")
                      }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </span>
            <!--댓글작성-->
            <div v-if="showBox == feedback.feedbackId" class="con_re_box">
              <div class="v_reply_int">
                <textarea v-model="newAnswer.content"></textarea>
                <a
                  href="javascript:void(0)"
                  @click="[saveAnswer(feedback)]"
                  class="v_reply_bt"
                  >{{ $t("common.save") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <h4>{{ $t("common.noData") }}</h4>
      </div>
    </div>
  </section>
</template>

<script>
import {
  getMgmtFeedbackList,
  saveFeedbackAnswer,
  deleteMgmtFeedback,
  // getMyFeedbackAuth,
  getMgmtFeedbackAnswerList,
} from "@/api/feedback";
export default {
  data() {
    return {
      docTypeList: [],
      productList: [],
      mainProd: [],
      subProd: [],
      subProductType: [],
      feedbackList: [],
      answerList: [],
      langList: [],
      form: {
        docTypeId: "",
        prodId: "",
        userId: "",
        upperProdId: "",
        startDate: "",
        endDate: "",
        searchWord: "",
        searchState: "",
        publishedYN: "",
        lang: "",
      },
      showBox: "",
      newAnswer: {
        parentId: "",
        feedbackType: "",
        docId: "",
        docverId: "",
        pageId: "",
        content: "",
      },
      tabName: "all",
      confirmYN: false,
    };
  },
  mounted() {
    this.fetchData(this.form);
  },
  methods: {
    // 분류조회
    async fetchData(form) {
      try {
        const { data } = await getMgmtFeedbackList(form);
        this.feedbackList = data.feedbackList;
        this.getAnswerList(form);
        this.docTypeList = data.docTypeList;
        this.mainProd = data.mainProd;
        this.subProd = data.subProd;
        this.langList = data.langList;
      } catch (err) {
        console.log(err);
      }
    },
    //답변 조회
    async getAnswerList() {
      try {
        this.form.searchState = "";
        const { data } = await getMgmtFeedbackAnswerList(this.form);
        this.answerList = data.answerList;
      } catch (err) {
        console.log(err);
      }
    },
    searchBtn() {
      this.fetchData(this.form);
    },
    showAnswerBox(feedbackId) {
      this.showBox = feedbackId;
    },
    async saveAnswer(feedback) {
      try {
        this.newAnswer.parentId = feedback.feedbackId;
        this.newAnswer.feedbackType = feedback.feedbackType;
        this.newAnswer.docId = feedback.docId;
        this.newAnswer.docverId = feedback.docverId;
        this.newAnswer.pageId = feedback.pageId;
        const { data } = await saveFeedbackAnswer(this.newAnswer);
        if (data.status) {
          this.showBox = "";
          this.newAnswer.content = "";
          this.fetchData(this.form);
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteFeedback(feedback) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteMgmtFeedback(feedback);
          if (data.status) {
            this.showBox = "";
            this.fetchData(this.form);
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
    // async getFeedbackManager() {
    //   try {
    //     const { data } = await getMyFeedbackAuth();
    //     console.log(data);
    //     if (data.auth == null) {
    //       this.feedbackList = null;
    //       this.answerList = null;
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    // getAll() {
    //   this.fetchData(this.form);
    // },
    // 대분류 선택시 중분류
    getSubProducts(prodId) {
      this.form.prodId = "";
      this.subProductType = [];
      for (let i in this.subProd) {
        if (prodId === this.subProd[i].upperProdId) {
          this.subProductType.push(this.subProd[i]);
        }
      }
    },
    // 날짜 validation
    checkDate() {
      if (this.form.endDate != "" && this.form.startDate != "") {
        if (this.form.endDate < this.form.startDate) {
          alert(this.$t("alert.checkDate"));
          this.form.endDate = "";
          this.form.startDate = "";
          return;
        }
      }
    },
  },
};
</script>

<style scoped>
.view_docbtn {
  display: block;
  border: 1px solid #ddd;
  width: 60px;
  text-align: center;
  line-height: 20px;
  margin-left: -1px;
  color: #a1a1a1;
  font-size: 11px;
}
.view_docbtn:hover {
  border: 1px solid #999;
  position: relative;
  color: #1a1a1a;
  background: #fff;
}
.b-form-datepicker {
  height: 35px !important;
  padding: 2px 0 15px 0;
}
</style>
